import React from 'react';

const CONFIG = {
  new: { label: 'Unpublished', color: '#e0b86b', border: 'rgba(224,184,107,.5)' },
  modified: { label: 'Modified', color: '#8fb8ce', border: 'rgba(143,184,206,.5)' },
  published: { label: 'Published', color: '#8fce8f', border: 'rgba(143,206,143,.5)' },
};

export default function StatusBadge({ status }) {
  const cfg = CONFIG[status];
  if (!cfg) return null;
  return (
    <span style={{ flex: '0 0 auto', fontSize: 11, letterSpacing: '.1em', textTransform: 'uppercase', color: cfg.color, border: `1px solid ${cfg.border}`, padding: '3px 8px' }}>
      {cfg.label}
    </span>
  );
}
